module.exports = __webpack_public_path__ + "img/maximo.7baa5e2d.jpg";